<template >
<vue-recaptcha 
  style="display: inline-block;" 
  sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
  @verify="onCaptchaVerified" :loadRecaptchaScript="true">
  </vue-recaptcha>
</template>
 
<script>
  import VueRecaptcha from 'vue-recaptcha';
  export default {
    components: { VueRecaptcha },
    methods: {
          onCaptchaVerified: function (recaptchaToken) {
            this.$emit('change', {
    
       });
    },
    }
  };
</script>